
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Entry": [
      "Agent",
      "AgentBadge",
      "Article",
      "ArticleCategory",
      "City",
      "County",
      "Page",
      "Plan",
      "Review",
      "Snippet",
      "SnippetGroup",
      "SnippetList"
    ],
    "PageSnippetsItem": [
      "Snippet",
      "SnippetGroup"
    ],
    "SnippetGroupSnippetsItem": [
      "Article",
      "Snippet"
    ],
    "SnippetLink": [
      "Agent",
      "Article",
      "Page"
    ]
  }
};
      export default result;
    